import { render, staticRenderFns } from "./EmpresasFat.vue?vue&type=template&id=63b35a01&scoped=true&"
import script from "./EmpresasFat.vue?vue&type=script&lang=js&"
export * from "./EmpresasFat.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasFat.vue?vue&type=style&index=0&id=63b35a01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b35a01",
  null
  
)

export default component.exports